/**
 * Rute-data.
 *
 *   BUS_ROUTE – buss linje 150: Guldbrandslia (Bærums Verk) → Vika Atrium
 *   CAR_ROUTE – bil: Bærums Verk → VIA P-hus / Onepark
 *
 * Bruker PROSESSERTE spor (pre-generert med `npm run routes`):
 * Matchet mot kartets veinett, delt ved tunnel/bro, uten offset/spline. Rå kilder ligger
 * ved siden av (150-*.geojson, route-car.geojson).
 */

import busRoute from './route-bus-processed.geojson';
import carRoute from './route-car-processed.geojson';
import portals from './route-portals.geojson';

export const BUS_ROUTE = busRoute;
export const CAR_ROUTE = carRoute;
export const ROUTE_PORTALS = portals;

// Startpunkt (første koordinat i første segment) for hver rute – brukes
// til å plassere kjøretøy-markørene ved rutestart.
function routeStart(fc) {
  const feat = fc.features ? fc.features[0] : fc;
  return feat.geometry.coordinates[0];
}
export const BUS_START = routeStart(busRoute);
export const CAR_START = routeStart(carRoute);

// Standardrute (bussen) for bakoverkompatibilitet.
export const ROUTE = busRoute;
